(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kv-card-product"] && !Shopify.designMode) return;
  try {
    /*
  Product card behaviour.

  Tooltips. An icon carrying data-kv-tooltip shows a small dark bubble with
  that text while the pointer rests on it, above the icon, or to its left when
  the icon asks with data-kv-tooltip-side="left". A toggle already switched on,
  a saved wishlist heart for example, shows data-kv-tooltip-added instead. The
  bubble is the same element kv-wishlist.js draws above the compare toggle, so
  all three icons look alike, and it only appears where there is a mouse and
  the screen is 1025px or wider, where the icons are shown.

  The bubble hangs off the page, outside every card, so the card's tooltip
  colours are copied onto the page's --kv-tooltip-bg and --kv-tooltip-color,
  which the bubble reads; the compare bubble follows them too.

  Quick view. A click on a [data-kv-quick-view] link fetches the product's
  card fragment with the popup markup inside it, loads the popup's stylesheet
  and script the first time, and opens the popup. While it loads the icon is
  marked busy and further clicks are ignored. Anything that goes wrong falls
  back to following the link to the product page.
*/
(() => {
  if (window.kvCardReady) return;
  window.kvCardReady = true;

  const TIP_MEDIA = window.matchMedia('(min-width: 1025px) and (hover: hover) and (pointer: fine)');

  /* Tooltip colours ------------------------------------------------------ */

  let coloursShared = false;
  const shareColours = (card) => {
    if (coloursShared || !card) return;
    const style = getComputedStyle(card);
    const background = style.getPropertyValue('--kv-card-tooltip-bg').trim();
    const colour = style.getPropertyValue('--kv-card-tooltip-color').trim();
    if (!background && !colour) return;
    const page = document.documentElement.style;
    if (background) page.setProperty('--kv-tooltip-bg', background);
    if (colour) page.setProperty('--kv-tooltip-color', colour);
    coloursShared = true;
  };

  /* Tooltips ------------------------------------------------------------- */

  let bubble = null;
  let anchor = null;

  const build = () => {
    bubble = document.createElement('div');
    bubble.className = 'kv-tooltip kv-tooltip--card';
    bubble.setAttribute('role', 'tooltip');
    bubble.innerHTML = '<span class="kv-tooltip__inner"></span><span class="kv-tooltip__arrow"></span>';
    document.body.appendChild(bubble);
    return bubble;
  };

  const switchedOn = (target) => {
    const input = target.querySelector('input[type="checkbox"]');
    return Boolean(input && input.checked);
  };

  const textFor = (target) =>
    (switchedOn(target) && target.dataset.kvTooltipAdded) || target.dataset.kvTooltip || '';

  const place = () => {
    if (!anchor || !bubble) return;
    const rect = anchor.getBoundingClientRect();
    if (bubble.classList.contains('kv-tooltip--left')) {
      bubble.style.left = `${rect.left}px`;
      bubble.style.top = `${rect.top + rect.height / 2}px`;
    } else {
      bubble.style.left = `${rect.left + rect.width / 2}px`;
      bubble.style.top = `${rect.top}px`;
    }
  };

  const show = (target) => {
    const text = textFor(target);
    if (!text) return;
    anchor = target;
    const node = bubble || build();
    node.querySelector('.kv-tooltip__inner').textContent = text;
    node.classList.toggle('kv-tooltip--left', target.dataset.kvTooltipSide === 'left');
    // Restarts the fade in when the bubble moves straight from one icon to another.
    node.classList.remove('is-visible');
    void node.offsetWidth;
    node.classList.add('is-visible');
    place();
  };

  const hide = () => {
    anchor = null;
    if (bubble) bubble.classList.remove('is-visible');
  };

  const tipTarget = (node) =>
    node && node.closest ? node.closest('.kv-card [data-kv-tooltip]') : null;

  document.addEventListener('mouseover', (event) => {
    const card = event.target.closest ? event.target.closest('.kv-card') : null;
    shareColours(card);
    const target = tipTarget(event.target);
    if (!target || target === anchor || !TIP_MEDIA.matches) return;
    show(target);
  });

  document.addEventListener('mouseout', (event) => {
    const target = tipTarget(event.target);
    if (target && target === anchor && !target.contains(event.relatedTarget)) hide();
  });

  // Keyboard focus shows the bubble too; a mouse click that leaves focus behind
  // does not keep it up after the pointer has gone.
  document.addEventListener('focusin', (event) => {
    const target = tipTarget(event.target);
    if (!target || !TIP_MEDIA.matches) return;
    if (event.target.matches && !event.target.matches(':focus-visible')) return;
    shareColours(target.closest('.kv-card'));
    show(target);
  });

  document.addEventListener('focusout', (event) => {
    if (tipTarget(event.target) === anchor) hide();
  });

  // A heart switched on or off changes its tooltip at once.
  document.addEventListener('kv:lists:change', () => {
    if (anchor) requestAnimationFrame(() => anchor && show(anchor));
  });

  window.addEventListener('scroll', place, { capture: true, passive: true });
  window.addEventListener('resize', place);

  /* Quick view ----------------------------------------------------------- */

  let loading = false;

  const loadStyle = (href) =>
    new Promise((resolve) => {
      if (!href || document.querySelector('link[data-kv-quick-view-style]')) {
        resolve();
        return;
      }
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.dataset.kvQuickViewStyle = '';
      link.addEventListener('load', () => resolve());
      link.addEventListener('error', () => resolve());
      document.head.appendChild(link);
    });

  const loadScript = (src) =>
    new Promise((resolve, reject) => {
      if (window.KvQuickView) {
        resolve();
        return;
      }
      let script = document.querySelector('script[data-kv-quick-view-script]');
      if (!script) {
        if (!src) {
          reject(new Error('no quick view script'));
          return;
        }
        script = document.createElement('script');
        script.src = src;
        script.dataset.kvQuickViewScript = '';
        document.head.appendChild(script);
      }
      script.addEventListener('load', () => (window.KvQuickView ? resolve() : reject(new Error('quick view missing'))));
      script.addEventListener('error', () => reject(new Error('quick view script failed')));
    });

  const openQuickView = async (link) => {
    if (loading) return;
    loading = true;
    link.setAttribute('aria-busy', 'true');
    const address = `${link.dataset.kvQuickView}?variant=${encodeURIComponent(
      link.dataset.kvQuickViewVariant || ''
    )}&section_id=kv-wishlist`;

    try {
      const response = await fetch(address, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`quick view request failed: ${response.status}`);
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const template = page.querySelector('template[data-kv-quick-view]');
      if (!template) throw new Error('no quick view in the response');
      await Promise.all([loadStyle(template.dataset.style), loadScript(template.dataset.script)]);
      window.KvQuickView.open(document.importNode(template, true), link);
    } catch (error) {
      window.location.href = link.href;
    } finally {
      loading = false;
      link.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest ? event.target.closest('[data-kv-quick-view]') : null;
    if (!link || event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    hide();
    openQuickView(link);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kv-carousel"] && !Shopify.designMode) return;
  try {
    /*
  Carousel behaviour.

  The track is a native scroller, so swiping, trackpad gestures and keyboard
  scrolling already work with no script at all. Everything here is an addition
  on top of that: it sizes the items, drives the arrows, and drives the
  draggable scrollbar. If this file fails to load the carousel still scrolls.

  Every measurement is read from the element or from a CSS custom property, so
  nothing about the look is decided here.

  Mouse dragging is on for every carousel: pressing on the track and moving the
  mouse scrolls it, the way a finger already does on a touch screen, and the
  release settles on the item grid the same way the arrows move. A carousel
  opts out with data-drag="false". Carousels written by hand, without that
  attribute, are therefore draggable too.

  Optional behaviour, all off unless the carousel element asks for it:
  - data-loop="true"      Wraps around. The first and last items are cloned
                          onto the far ends so a swipe past the last item lands
                          on the first one, then the scroller quietly jumps back
                          onto the real item once it comes to rest.
  - data-autoplay="6000"  Moves on by one step every so many milliseconds.
                          Pauses while a mouse is over the carousel, while
                          something inside it has keyboard focus, while a finger
                          or a mouse is dragging it, and while the tab is hidden.
                          Never runs for visitors who ask for reduced motion.
  - data-duration="700"   Length in milliseconds of every move the carousel
                          makes by itself (arrows, dots, autoplay, releasing a
                          drag). Without it those moves use the browser's own
                          smooth scroll.
  - data-easing="0.25,0.1,0.25,1"
                          The timing curve of those moves, as the four numbers
                          of a CSS cubic-bezier(). Defaults to CSS "ease".
  - [data-kv-carousel-dots] containing one [data-kv-carousel-dot] per item:
                          each dot jumps to its item, and the dot for the item
                          on screen carries aria-current="true".
  - data-direction="vertical"
                          Runs the carousel down the page instead of across it.
                          The stylesheet stacks the items and scrolls the
                          viewport up and down; everything here then measures
                          and moves the same way. The scrollbar control is only
                          drawn across, so it is left out of this mode.
  - data-step="1"         How many items one press of an arrow moves. Without
                          it a press moves a whole screenful.
*/

(() => {
  // Should the code ever be loaded twice on one page, the second copy is
  // stopped here rather than being allowed to register a second set of
  // listeners.
  if (window.kvCarouselReady) return;
  window.kvCarouselReady = true;

  const SELECTOR = '.kv-carousel';

  // How many items are visible at each width. The two thresholds match the
  // breakpoints the stylesheet uses: tablets start at 769px, desktops at 1025px.
  const BREAKPOINT_MD = 769;
  const BREAKPOINT_LG = 1025;

  // Below a pixel of difference the scroller is treated as parked at an end.
  // Browsers report fractional scroll positions, so an exact comparison would
  // leave the last arrow enabled on a fully scrolled track.
  const EDGE_EPSILON = 1;

  // A mouse has to travel this far before a press becomes a drag, so a plain
  // click on a link inside an item still reaches the link.
  const DRAG_THRESHOLD = 5;

  // A drag released quickly counts as a flick and moves on even when short; a
  // slow drag has to cover this share of an item before it moves on.
  const FLICK_MS = 300;
  const DRAG_RATIO = 0.5;

  // How long the scroller must stay still before it is considered at rest, for
  // browsers that do not fire scrollend.
  const SETTLE_MS = 120;

  const toNumber = (value, fallback) => {
    const parsed = parseFloat(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
  };

  const reducedMotion = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // CSS "ease", used when a carousel names no timing curve of its own.
  const CSS_EASE = [0.25, 0.1, 0.25, 1];

  /*
    A CSS cubic-bezier() timing curve: given the share of the move's time that
    has passed, returns the share of the distance covered, so a scripted move
    feels like a CSS transition with the same curve and length.
  */
  const bezier = (x1, y1, x2, y2) => {
    const cx = 3 * x1;
    const bx = 3 * (x2 - x1) - cx;
    const ax = 1 - cx - bx;
    const cy = 3 * y1;
    const by = 3 * (y2 - y1) - cy;
    const ay = 1 - cy - by;
    const curveX = (t) => ((ax * t + bx) * t + cx) * t;
    const curveY = (t) => ((ay * t + by) * t + cy) * t;

    return (time) => {
      if (time <= 0) return 0;
      if (time >= 1) return 1;

      // Newton's method converges in a few steps on ordinary curves.
      let t = time;
      for (let i = 0; i < 8; i++) {
        const error = curveX(t) - time;
        if (Math.abs(error) < 1e-6) return curveY(t);
        const slope = (3 * ax * t + 2 * bx) * t + cx;
        if (Math.abs(slope) < 1e-6) break;
        t -= error / slope;
      }

      // A curve with a flat stretch can stall it, so halving finishes the job.
      let low = 0;
      let high = 1;
      t = time;
      while (high - low > 1e-6) {
        if (curveX(t) < time) low = t;
        else high = t;
        t = (low + high) / 2;
      }
      return curveY(t);
    };
  };

  // Reads data-easing; anything that is not a valid curve falls back to "ease".
  const easingFrom = (value) => {
    const points = String(value || '')
      .split(',')
      .map((part) => parseFloat(part));
    const valid =
      points.length === 4 &&
      points.every(Number.isFinite) &&
      points[0] >= 0 &&
      points[0] <= 1 &&
      points[2] >= 0 &&
      points[2] <= 1;
    return bezier(...(valid ? points : CSS_EASE));
  };

  class KvCarousel {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector('.kv-carousel__viewport');
      this.track = root.querySelector('.kv-carousel__track');
      if (!this.viewport || !this.track) return;

      // The arrow pair normally lives inside the carousel. A section may instead
      // place it elsewhere, for example on its heading row, by giving the
      // carousel an id and the pair a data-kv-carousel-controls attribute that
      // names that id. Pairs inside the carousel still win when both exist.
      this.controls = root.id
        ? document.querySelector(`[data-kv-carousel-controls="${CSS.escape(root.id)}"]`)
        : null;
      this.prevButton =
        root.querySelector('[data-kv-carousel-prev]') ||
        (this.controls && this.controls.querySelector('[data-kv-carousel-prev]'));
      this.nextButton =
        root.querySelector('[data-kv-carousel-next]') ||
        (this.controls && this.controls.querySelector('[data-kv-carousel-next]'));
      this.scrollbar = root.querySelector('[data-kv-carousel-scrollbar]');
      this.thumb = root.querySelector('[data-kv-carousel-thumb]');

      this.perView = {
        lg: toNumber(root.dataset.perView, 5),
        md: toNumber(root.dataset.perViewMd, 3),
        sm: toNumber(root.dataset.perViewSm, 1),
      };

      // Optional behaviour. Each stays off unless the markup asks for it.
      this.dots = [...root.querySelectorAll('[data-kv-carousel-dot]')];
      // How many items one press of an arrow moves. Zero means a whole screenful.
      this.step = toNumber(root.dataset.step, 0);
      this.duration = toNumber(root.dataset.duration, 0);
      this.ease = easingFrom(root.dataset.easing);
      this.autoplayDelay = toNumber(root.dataset.autoplay, 0);
      // On unless the markup turns it off, so hand written carousels drag too.
      this.dragEnabled = root.dataset.drag !== 'false';
      this.realItems = [...this.track.children].filter((el) =>
        el.classList.contains('kv-carousel__item')
      );
      this.loop = root.dataset.loop === 'true' && this.realItems.length > 1;
      this.indexed =
        this.loop ||
        this.dragEnabled ||
        this.dots.length > 0 ||
        this.duration > 0 ||
        this.autoplayDelay > 0;
      if (this.autoplayDelay) this.pauses = new Set();

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onThumbKeydown = this.onThumbKeydown.bind(this);

      this.readDirection();

      if (this.loop) this.buildClones();

      this.bind();
      if (this.indexed) this.bindOptional();
      this.apply();

      root.classList.add('kv-carousel--ready');
      // Lets the stylesheet offer the grab cursor only where a drag works.
      root.classList.toggle('kv-carousel--draggable', this.dragEnabled);

      if (this.autoplayDelay) this.scheduleAutoplay();
    }

    bind() {
      this.viewport.addEventListener('scroll', this.onScroll, { passive: true });

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.page(-1));
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.page(1));
      }

      if (this.thumb) {
        this.thumb.addEventListener('pointerdown', this.onPointerDown);
        this.thumb.addEventListener('keydown', this.onThumbKeydown);
      }

      // Clicking the empty part of the track jumps there, the way a real
      // scrollbar behaves. The bar is drawn across, so it is left alone by a
      // carousel that runs down the page.
      if (this.scrollbar && !this.vertical) {
        this.scrollbar.addEventListener('pointerdown', (event) => {
          if (event.target === this.thumb) return;
          this.scrollToRatio(this.ratioFromPointer(event.clientX));
        });
      }

      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.onResize);
        this.observer.observe(this.viewport);
      } else {
        window.addEventListener('resize', this.onResize);
      }
    }

    /* Sizing ------------------------------------------------------------ */

    get visibleCount() {
      const width = window.innerWidth;
      if (width >= BREAKPOINT_LG) return this.perView.lg;
      if (width >= BREAKPOINT_MD) return this.perView.md;
      return this.perView.sm;
    }

    // How many items one arrow press moves: the number asked for, otherwise a
    // whole screenful.
    get stepCount() {
      return this.step > 0 ? this.step : this.visibleCount;
    }

    /* Axis ----------------------------------------------------------------

      A carousel runs across the page unless it is asked to run down it
      instead, either by the markup, with data-direction="vertical", or by the
      stylesheet, with --kv-carousel-direction. The stylesheet has the last
      word, so one carousel can stand on its side beside something on a wide
      screen and lie flat under it on a narrow one; the direction is read
      again whenever the carousel measures itself.

      These few readings and writings are the only place that knows which way
      it runs, so everything else below works the same either way.
    */
    readDirection() {
      const declared = getComputedStyle(this.root).getPropertyValue('--kv-carousel-direction').trim();
      const wasVertical = this.isVertical;
      this.isVertical = declared ? declared === 'vertical' : this.root.dataset.direction === 'vertical';

      // Turned the other way, the scroller is back at the start: its old
      // offset belonged to the other axis.
      if (wasVertical !== undefined && wasVertical !== this.isVertical) {
        this.cancelAnimation();
        this.viewport.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      }
    }

    get vertical() {
      return this.isVertical;
    }

    get position() {
      return this.vertical ? this.viewport.scrollTop : this.viewport.scrollLeft;
    }

    set position(value) {
      if (this.vertical) this.viewport.scrollTop = value;
      else this.viewport.scrollLeft = value;
    }

    // A scroll instruction aimed along the way this carousel runs.
    along(value, behavior) {
      return this.vertical ? { top: value, behavior } : { left: value, behavior };
    }

    get viewportSize() {
      return this.vertical ? this.viewport.clientHeight : this.viewport.clientWidth;
    }

    get contentSize() {
      return this.vertical ? this.viewport.scrollHeight : this.viewport.scrollWidth;
    }

    // Where an item starts, measured along the way the carousel runs.
    startOf(item) {
      return this.vertical ? item.offsetTop : item.offsetLeft;
    }

    sizeOf(item) {
      const rect = item.getBoundingClientRect();
      return this.vertical ? rect.height : rect.width;
    }

    /*
      The item width is published as a custom property rather than written onto
      each item, so the stylesheet keeps ownership of the layout and one write
      resizes every item at once.
    */
    apply() {
      this.readDirection();
      this.root.style.setProperty('--kv-carousel-visible', String(this.visibleCount));

      // A wrapping carousel keeps its place when its width changes: the item
      // widths change with it, and so does the scroll offset of the current item.
      // A height change, such as a picture finishing loading, moves nothing. A
      // move under way was aimed at the old widths, so it ends on its target.
      if (this.loop) {
        const width = this.viewportSize;
        if (width !== this.lastWidth) {
          this.lastWidth = width;
          if (this.dragging || this.touching) {
            this.reanchorPending = true;
          } else {
            const index = this.animation ? this.targetIndex : this.currentIndex;
            this.jumpTo(index === undefined ? 0 : index);
          }
        }
      }

      this.update();
    }

    /* State -------------------------------------------------------------- */

    get maxScroll() {
      return Math.max(0, this.contentSize - this.viewportSize);
    }

    update() {
      if (this.loop) {
        this.updateLooped();
        return;
      }

      const max = this.maxScroll;
      const position = this.position;
      const scrollable = max > EDGE_EPSILON;

      if (this.prevButton) {
        this.prevButton.disabled = !scrollable || position <= EDGE_EPSILON;
      }
      if (this.nextButton) {
        this.nextButton.disabled = !scrollable || position >= max - EDGE_EPSILON;
      }

      // Nothing to scroll means nothing to indicate. Hiding the whole control
      // is clearer than leaving a thumb that fills its track.
      this.root.classList.toggle('kv-carousel--static', !scrollable);
      if (this.controls) {
        this.controls.classList.toggle('kv-carousel__arrows--static', !scrollable);
      }

      // The scrollbar is drawn across, so it is offered for a carousel that
      // runs that way.
      if (this.thumb && !this.vertical) {
        // The thumb covers the share of items on screen. Adding one gap to both
        // sides counts every item with its trailing gap, so five of twelve items
        // give a thumb exactly five twelfths of the track, whatever the gap.
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const ratio =
          (this.viewport.clientWidth + gap) / Math.max(1, this.viewport.scrollWidth + gap);
        const progress = max > 0 ? position / max : 0;

        this.thumb.style.width = `${Math.min(100, ratio * 100)}%`;

        // The thumb travels the part of the track it does not itself cover, so
        // its trailing edge lands exactly on the track end at full scroll.
        this.thumb.style.left = `${progress * (100 - Math.min(100, ratio * 100))}%`;
        this.thumb.setAttribute('aria-valuenow', String(Math.round(progress * 100)));
      }

      if (this.indexed) this.updateIndex();
    }

    onScroll() {
      // Without scrollend, rest is inferred from the scroll events stopping.
      if (this.indexed && !this.supportsScrollEnd) {
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.onSettle(), SETTLE_MS);
      }

      // Scroll fires far more often than a frame, so the read is deferred to
      // the next frame and coalesced.
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    }

    onResize() {
      this.apply();
    }

    /* Moving -------------------------------------------------------------- */

    /*
      One press moves by one screenful, or by the number of items the markup
      asks for, matched to the item grid so the row never comes to rest with an
      item cut in half.
    */
    page(direction) {
      if (this.indexed) {
        // A wrapping carousel lets a move finish before it takes the next
        // press. Presses piled up during a move would otherwise aim further
        // round than the copies at that end reach, and the track would run the
        // wrong way to get there.
        if (this.loop && this.moving) return;
        this.goTo(this.baseIndex + direction * this.stepCount, direction);
        this.restartAutoplay();
        return;
      }

      // The first item that is actually laid out: a row may keep hidden items
      // in its markup, and a hidden one measures zero.
      const item = [...this.track.querySelectorAll('.kv-carousel__item')].find(
        (el) => el.getClientRects().length > 0
      );
      const step = item ? this.sizeOf(item) * this.stepCount : this.viewportSize;

      this.viewport.scrollBy(this.along(step * direction, 'smooth'));
    }

    scrollToRatio(ratio) {
      const clamped = Math.min(1, Math.max(0, ratio));
      this.viewport.scrollTo(this.along(clamped * this.maxScroll, 'auto'));
    }

    /*
      Maps a pointer position on the scrollbar to a scroll ratio. The thumb has
      width, so the distance it can travel is the track minus the thumb; using
      the full track width would make the carousel run out before the pointer
      reached the end.
    */
    ratioFromPointer(clientX) {
      const track = this.scrollbar.getBoundingClientRect();
      const thumbWidth = this.thumb ? this.thumb.getBoundingClientRect().width : 0;
      const travel = Math.max(1, track.width - thumbWidth);
      return (clientX - track.left - thumbWidth / 2) / travel;
    }

    /* Dragging the thumb --------------------------------------------------- */

    onPointerDown(event) {
      event.preventDefault();
      this.dragging = true;
      this.thumb.setPointerCapture(event.pointerId);
      this.root.classList.add('kv-carousel--dragging');

      this.thumb.addEventListener('pointermove', this.onPointerMove);
      this.thumb.addEventListener('pointerup', this.onPointerUp);
      this.thumb.addEventListener('pointercancel', this.onPointerUp);
    }

    onPointerMove(event) {
      if (!this.dragging) return;
      this.scrollToRatio(this.ratioFromPointer(event.clientX));
    }

    onPointerUp(event) {
      this.dragging = false;
      this.root.classList.remove('kv-carousel--dragging');

      if (this.thumb.hasPointerCapture(event.pointerId)) {
        this.thumb.releasePointerCapture(event.pointerId);
      }
      this.thumb.removeEventListener('pointermove', this.onPointerMove);
      this.thumb.removeEventListener('pointerup', this.onPointerUp);
      this.thumb.removeEventListener('pointercancel', this.onPointerUp);

      // A thumb drag can come to rest on a copy of a wrapping carousel.
      if (this.indexed) this.onSettle();
    }

    onThumbKeydown(event) {
      const back = event.key === 'ArrowLeft' || event.key === 'ArrowUp';
      const forward = event.key === 'ArrowRight' || event.key === 'ArrowDown';
      if (!back && !forward) return;

      event.preventDefault();
      this.page(back ? -1 : 1);
    }

    /* ================================================================ */
    /* Optional behaviour                                                  */
    /* ================================================================ */

    bindOptional() {
      this.supportsScrollEnd = 'onscrollend' in window;
      if (this.supportsScrollEnd) {
        this.viewport.addEventListener('scrollend', () => this.onSettle());
      }

      // A finger resting on the track, or scrolling the page the other way,
      // lets a move under way finish. Only a swipe along the way the carousel
      // runs takes the scroller over.
      this.viewport.addEventListener(
        'touchstart',
        (event) => {
          this.touching = true;
          // A second finger landing must not re-start the reading: the gesture
          // is still the first finger's, from where it first touched down.
          if (event.touches.length > 1) return;
          const touch = event.touches[0];
          this.touchStart = touch ? { x: touch.clientX, y: touch.clientY } : null;
          this.touchSideways = false;
        },
        { passive: true }
      );
      this.viewport.addEventListener(
        'touchmove',
        (event) => {
          const touch = event.touches[0];
          if (this.touchSideways || !touch || !this.touchStart) return;
          const across = Math.abs(touch.clientX - this.touchStart.x);
          const down = Math.abs(touch.clientY - this.touchStart.y);
          const dx = this.vertical ? down : across;
          const dy = this.vertical ? across : down;
          if (dx < DRAG_THRESHOLD || dx <= dy) return;
          this.touchSideways = true;
          if (this.animation) this.cancelAnimation();
        },
        { passive: true }
      );
      // A scrollend that arrived while the finger was still down was ignored and
      // is not repeated, so rest is also checked for once the finger lifts. A
      // swipe that moved the slides starts the autoplay wait again; a page
      // scroll that began on the track leaves it running.
      const release = (event) => {
        // Still fingers on the track: the gesture is not over, and nothing may
        // move the scroller while they rest there.
        if (event && event.type === 'touchend' && event.touches.length) return;
        this.touching = false;
        if (this.touchSideways) this.restartAutoplay();
        this.touchSideways = false;
        this.touchStart = null;
        this.settleWhenStill();
      };
      this.viewport.addEventListener('touchend', release, { passive: true });
      this.viewport.addEventListener('touchcancel', release, { passive: true });

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.goTo(index);
          this.restartAutoplay();
        });
      });

      if (this.dragEnabled) {
        this.onDragDown = this.onDragDown.bind(this);
        this.onDragMove = this.onDragMove.bind(this);
        this.onDragUp = this.onDragUp.bind(this);
        this.onDragAbort = this.onDragAbort.bind(this);
        this.viewport.addEventListener('pointerdown', this.onDragDown);
        // Pictures and links would otherwise start the browser's own drag and
        // drop, which steals the gesture.
        this.viewport.addEventListener('dragstart', (event) => event.preventDefault());
      }

      if (this.autoplayDelay) {
        // Only a real mouse pauses on hover: a tap on a touch screen reports an
        // enter with no matching leave and would stop the carousel for good.
        this.root.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse') this.pause('hover');
        });
        this.root.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'mouse') this.resume('hover');
        });

        // Keyboard focus pauses; a mouse click that leaves a button focused
        // does not, or the carousel would stay stopped after the pointer left.
        this.root.addEventListener('focusin', (event) => {
          if (event.target.matches && event.target.matches(':focus-visible')) this.pause('focus');
        });
        this.root.addEventListener('focusout', (event) => {
          if (!this.root.contains(event.relatedTarget)) this.resume('focus');
        });
        this.root.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse') this.resume('focus');
        });

        this.onVisibility = () => {
          if (document.hidden) this.pause('hidden');
          else this.resume('hidden');
        };
        document.addEventListener('visibilitychange', this.onVisibility);

        // A page opened in a background tab starts out hidden, with no change
        // event to say so.
        if (document.hidden) this.pauses.add('hidden');
      }
    }

    // A pause keeps the part of the wait already served, so the next step comes
    // when the rest of it has passed rather than a whole wait later.
    pause(reason) {
      if (!this.pauses) return;
      if (this.autoplayTimer && this.autoplayLeft === undefined) {
        this.autoplayLeft = Math.max(0, this.autoplayDue - performance.now());
      }
      this.pauses.add(reason);
      this.stopAutoplay();
    }

    // Only a reason that actually paused the carousel can start it again.
    resume(reason) {
      if (!this.pauses || !this.pauses.delete(reason)) return;
      if (this.pauses.size) return;
      const left = this.autoplayLeft;
      this.autoplayLeft = undefined;
      this.scheduleAutoplay(left === undefined ? this.autoplayDelay : left);
    }

    /* Theme editor ----------------------------------------------------------- */

    // Selecting a slide's block brings that slide into view and holds it there.
    selectBlock(element) {
      const item = element.closest('.kv-carousel__item');
      if (!item || !this.track.contains(item)) return;
      const index = this.visibleRealItems.indexOf(item);
      if (index < 0) return;
      this.pause('editor');
      // The selection moved the slides, so a full wait follows the deselect.
      this.autoplayLeft = undefined;
      this.jumpTo(index);
      this.update();
    }

    deselectBlock() {
      this.resume('editor');
    }

    // The editor replaced or removed the section: nothing may keep running.
    destroy() {
      this.destroyed = true;
      // First, so the drag's release cannot start a move after the cleanup.
      if (this.drag) this.onDragAbort();
      this.stopAutoplay();
      this.cancelAnimation();
      clearTimeout(this.settleTimer);
      if (this.observer) this.observer.disconnect();
      else window.removeEventListener('resize', this.onResize);
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }

    /* Index ------------------------------------------------------------- */

    // Every item in the track, clones included, that is actually laid out.
    get laidOutItems() {
      return [...this.track.children].filter(
        (el) => el.classList.contains('kv-carousel__item') && el.getClientRects().length > 0
      );
    }

    // Items can be reordered visually with CSS order, so the start of the track
    // is the first laid out item along the way it runs, not the first one in
    // the markup.
    offsetOf(item) {
      const items = this.laidOutItems;
      if (!items.length) return 0;
      const start = Math.min(...items.map((el) => this.startOf(el)));
      return this.startOf(item) - start;
    }

    // The laid out item whose start is nearest the current scroll position.
    nearestItem() {
      const items = this.laidOutItems;
      const position = this.position;
      let best = null;
      let bestDistance = Infinity;
      items.forEach((item) => {
        const distance = Math.abs(this.offsetOf(item) - position);
        if (distance < bestDistance) {
          best = item;
          bestDistance = distance;
        }
      });
      return best;
    }

    get visibleRealItems() {
      return this.realItems
        .filter((el) => el.getClientRects().length > 0)
        .sort((a, b) => this.startOf(a) - this.startOf(b));
    }

    // Where the next step counts from: the item a move under way is heading for,
    // otherwise the item on screen. Reading it off the scroll position mid-move
    // would count from whatever the scroller happens to be passing.
    get baseIndex() {
      if (this.moving && this.targetIndex !== undefined) return this.targetIndex;
      return this.currentIndex === undefined ? this.readIndex() : this.currentIndex;
    }

    // Index among the real items of the item now at the start of the viewport.
    readIndex() {
      const item = this.nearestItem();
      if (!item) return 0;
      if (item.dataset.kvCloneOf !== undefined) return Number(item.dataset.kvCloneOf);
      const index = this.visibleRealItems.indexOf(item);
      return index < 0 ? 0 : index;
    }

    // While a move is under way the dots already show where it is going, the
    // moment it starts, rather than switching halfway across.
    updateIndex() {
      const index = this.moving && this.targetIndex !== undefined ? this.targetIndex : this.readIndex();
      this.currentIndex = index;

      this.dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });

      if (index !== this.lastAnnounced) {
        this.lastAnnounced = index;
        this.root.dispatchEvent(new CustomEvent('kv-carousel:change', { detail: { index } }));
      }
    }

    /* Wrapping ------------------------------------------------------------ */

    buildClones() {
      // Copies follow the order the items are shown in, which CSS order can make
      // different from the markup, and skip items hidden at this width.
      const items = this.visibleRealItems;
      const count = items.length;

      // A page step can cover a whole screenful, so each end needs enough copies
      // for a step that starts on the last screenful to land on a copy.
      const widest = Math.max(this.perView.lg, this.perView.md, this.perView.sm);
      const perSide = Math.min(count, widest * 2);

      items.forEach((item, index) => {
        item.dataset.kvRealIndex = String(index);
      });

      const orders = items.map((item) => parseFloat(getComputedStyle(item).order) || 0);
      const lowest = Math.min(...orders);
      const highest = Math.max(...orders);

      const makeClone = (item, index, order) => {
        const clone = item.cloneNode(true);
        clone.dataset.kvCloneOf = String(index);
        delete clone.dataset.kvRealIndex;
        clone.classList.add('kv-carousel__item--clone');
        clone.setAttribute('aria-hidden', 'true');
        clone.inert = true;
        if (lowest !== 0 || highest !== 0) clone.style.order = String(order);

        // A copy must not repeat ids or register as a theme editor block. Its
        // pictures keep their loading hint, so a lazy one stays lazy.
        [clone, ...clone.querySelectorAll('*')].forEach((el) => {
          el.removeAttribute('id');
          [...el.attributes].forEach((attr) => {
            if (attr.name.startsWith('data-shopify')) el.removeAttribute(attr.name);
          });
        });
        return clone;
      };

      this.clonesBefore = items
        .slice(count - perSide)
        .map((item, i) => makeClone(item, count - perSide + i, lowest - 1));
      this.clonesAfter = items.slice(0, perSide).map((item, i) => makeClone(item, i, highest + 1));

      this.track.prepend(...this.clonesBefore);
      this.track.append(...this.clonesAfter);

      // The clones before the first item would otherwise be what shows first.
      this.currentIndex = 0;
      this.jumpTo(0);
    }

    updateLooped() {
      const count = this.visibleRealItems.length;
      const scrollable = count > this.visibleCount;

      if (this.prevButton) this.prevButton.disabled = !scrollable;
      if (this.nextButton) this.nextButton.disabled = !scrollable;

      this.root.classList.toggle('kv-carousel--static', !scrollable);
      if (this.controls) {
        this.controls.classList.toggle('kv-carousel__arrows--static', !scrollable);
      }

      this.updateIndex();

      if (this.thumb) {
        const ratio = Math.min(1, this.visibleCount / Math.max(1, count));
        const progress = count > this.visibleCount ? this.currentIndex / (count - this.visibleCount) : 0;
        const clamped = Math.min(1, Math.max(0, progress));
        this.thumb.style.width = `${ratio * 100}%`;
        this.thumb.style.left = `${clamped * (100 - ratio * 100)}%`;
        this.thumb.setAttribute('aria-valuenow', String(Math.round(clamped * 100)));
      }
    }

    // Once the scroller rests on a clone, move it onto the real item it copies.
    // The two look identical, so the jump cannot be seen.
    normalizeLoop() {
      if (!this.loop || this.touching || this.dragging || this.animation) return;
      const item = this.nearestItem();
      if (item && item.dataset.kvCloneOf !== undefined) {
        this.jumpTo(Number(item.dataset.kvCloneOf));
      }
    }

    onSettle() {
      if (this.destroyed || this.touching || this.dragging || this.animation) return;
      this.moving = false;
      if (this.restoreSnapOnSettle) {
        this.restoreSnapOnSettle = false;
        this.viewport.style.scrollSnapType = '';
      }
      if (this.reanchorPending) {
        this.reanchorPending = false;
        this.jumpTo(this.readIndex());
      }
      this.normalizeLoop();
      this.update();
    }

    // Settles once the scroller has stopped moving, however long its momentum lasts.
    settleWhenStill() {
      clearTimeout(this.settleTimer);
      const position = this.position;
      this.settleTimer = setTimeout(() => {
        if (Math.abs(this.position - position) > EDGE_EPSILON) this.settleWhenStill();
        else this.onSettle();
      }, SETTLE_MS);
    }

    /*
      Shifts the scroller by one full set of items when it sits past either end
      of the real items, onto the matching spot among the real ones. Both spots
      look identical. It makes room for a drag, and for a move that has no copy
      of its target left in the direction it has to go.
    */
    rebaseLoop() {
      if (!this.loop || !this.clonesAfter.length) return false;
      const items = this.visibleRealItems;
      const count = items.length;
      if (!count) return false;

      const first = this.offsetOf(items[0]);
      const last = this.offsetOf(items[count - 1]);
      const firstCopy = this.clonesAfter.find((clone) => clone.dataset.kvCloneOf === '0');
      if (!firstCopy) return false;
      const period = this.offsetOf(firstCopy) - first;

      const position = this.position;
      let shifted = null;
      if (position > last + EDGE_EPSILON) shifted = position - period;
      else if (position < first - EDGE_EPSILON) shifted = position + period;
      if (shifted === null) return false;

      this.cancelAnimation(false);
      this.viewport.style.scrollSnapType = 'none';
      this.viewport.scrollTo(this.along(shifted, 'instant'));
      return true;
    }

    /* Scripted moves -------------------------------------------------------- */

    /*
      In a wrapping carousel every item exists up to three times: the real one
      and a copy at each end. A move picks the copy that suits its direction -
      the nearest one ahead when going forward, behind when going back, and the
      nearest either way for a jump to a named item - so the track always runs
      the short way in the direction the visitor asked for. The scroller is moved
      onto the real item once it comes to rest.
    */
    loopTarget(index, direction) {
      const items = this.visibleRealItems;
      const count = items.length;
      const wrapped = ((index % count) + count) % count;
      const copies = [items[wrapped]].concat(
        this.clonesBefore.concat(this.clonesAfter).filter(
          (clone) => clone.dataset.kvCloneOf === String(wrapped)
        )
      );

      const pick = () => {
        const position = this.position;
        let best = null;
        copies.forEach((copy) => {
          const offset = this.offsetOf(copy);
          // With several items per view, the copies at the very end can never
          // be scrolled to the start of the viewport.
          if (offset > this.maxScroll + EDGE_EPSILON) return;
          const ahead = offset - position;
          if (direction > 0 && ahead < -EDGE_EPSILON) return;
          if (direction < 0 && ahead > EDGE_EPSILON) return;
          if (best === null || Math.abs(ahead) < Math.abs(best - position)) best = offset;
        });
        return best;
      };

      let left = pick();
      if (left === null && this.rebaseLoop()) left = pick();
      return left === null ? this.offsetOf(items[wrapped]) : left;
    }

    // direction: 1 forward, -1 back, 0 straight to the named item.
    targetFor(index, direction = 0) {
      const items = this.visibleRealItems;
      const count = items.length;
      if (!count) return null;

      if (this.loop) return this.loopTarget(index, direction);

      const clamped = Math.min(count - 1, Math.max(0, index));
      return Math.min(this.maxScroll, this.offsetOf(items[clamped]));
    }

    goTo(index, direction = 0) {
      if (this.destroyed) return;
      const count = this.visibleRealItems.length;
      const left = count ? this.targetFor(index, direction) : null;
      if (left === null) {
        this.viewport.style.scrollSnapType = '';
        return;
      }

      this.targetIndex = this.loop
        ? ((index % count) + count) % count
        : Math.min(count - 1, Math.max(0, index));
      this.scrollToLeft(left);
      this.updateIndex();
    }

    jumpTo(index) {
      const items = this.visibleRealItems;
      if (!items.length) return;
      const wrapped = ((index % items.length) + items.length) % items.length;
      this.cancelAnimation();
      this.viewport.scrollTo(this.along(this.offsetOf(items[wrapped]), 'instant'));
      this.currentIndex = wrapped;
    }

    // Starts a move. It counts as under way until the scroller comes to rest.
    scrollToLeft(left) {
      if (this.duration && reducedMotion()) {
        // Snapping may have been lifted by a drag or a re-base just before.
        this.viewport.style.scrollSnapType = '';
        this.viewport.scrollTo(this.along(left, 'instant'));
        this.onSettle();
        return;
      }

      if (!this.duration) {
        // A scroll to where the scroller already is never reports an end.
        const distance = Math.abs(left - this.position);
        this.moving = distance > EDGE_EPSILON;

        // Snapping lifted by a drag stays lifted until the move ends: put back
        // halfway between two items, it would make the browser jump the track
        // to the nearer one before the move could start.
        if (this.moving && this.viewport.style.scrollSnapType === 'none') {
          this.restoreSnapOnSettle = true;
        } else {
          this.viewport.style.scrollSnapType = '';
        }
        this.viewport.scrollTo(this.along(left, 'smooth'));
        return;
      }

      this.animate(left);
    }

    /*
      Scripted scrolling with a set length. Snapping is lifted for the length of
      the move, otherwise the browser snaps every intermediate frame and the
      motion stutters; the move always ends on a snap point, so restoring it
      changes nothing.
    */
    animate(left) {
      // A move under way is replaced where it stands. Snapping stays lifted in
      // between; putting it back first would let the browser jump the track to
      // the nearest item before this move reads its starting point.
      this.cancelAnimation(false);
      const start = this.position;
      const distance = left - start;
      if (Math.abs(distance) < EDGE_EPSILON) {
        // Already there, possibly straight after a drag that lifted snapping.
        this.viewport.style.scrollSnapType = '';
        this.onSettle();
        return;
      }

      this.viewport.style.scrollSnapType = 'none';
      this.moving = true;
      this.animationLeft = left;
      const began = performance.now();
      const step = (now) => {
        const progress = Math.min(1, (now - began) / this.duration);
        this.position = start + distance * this.ease(progress);
        if (progress < 1) {
          this.animation = requestAnimationFrame(step);
        } else {
          this.animation = null;
          this.viewport.style.scrollSnapType = '';
          this.onSettle();
        }
      };
      this.animation = requestAnimationFrame(step);
    }

    // Stops a move where it is. Whatever takes over decides where to go next.
    cancelAnimation(restoreSnap = true) {
      this.moving = false;
      if (!this.animation) return;
      cancelAnimationFrame(this.animation);
      this.animation = null;
      if (restoreSnap) this.viewport.style.scrollSnapType = '';
    }

    /* Mouse dragging ------------------------------------------------------- */

    onDragDown(event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (event.target.closest('input, textarea, select, [contenteditable]')) return;

      // A drag whose release was never seen, for example because the window
      // lost focus, is cleared before a new one starts.
      if (this.drag || this.dragging) this.onDragAbort();

      // A row with nothing to scroll has nothing to drag.
      if (this.root.classList.contains('kv-carousel--static')) return;

      // Stops text selection starting under the pointer; the click that follows
      // a press without a drag still fires.
      event.preventDefault();

      // A press on its own changes nothing: a move under way carries on, the
      // same as under a finger resting on a touch screen. The track is taken
      // over only once the pointer has travelled far enough to be a drag.
      this.drag = {
        x: this.pointOf(event),
        lastX: this.pointOf(event),
        time: performance.now(),
        moved: false,
      };

      // Captured on the window so nothing further down the page can stop them.
      window.addEventListener('pointermove', this.onDragMove, true);
      window.addEventListener('pointerup', this.onDragUp, true);
      window.addEventListener('pointercancel', this.onDragUp, true);
      window.addEventListener('blur', this.onDragAbort);
    }

    // Ends a drag without a pointer event: settles on the nearest item.
    onDragAbort() {
      const drag = this.drag;
      if (drag) {
        this.onDragUp({ clientX: drag.lastX, aborted: true });
        return;
      }
      this.dragging = false;
      this.root.classList.remove('kv-carousel--grabbing');
      this.viewport.style.scrollSnapType = '';
    }

    // The pointer coordinate along the way the carousel runs.
    pointOf(event) {
      return this.vertical ? event.clientY : event.clientX;
    }

    onDragMove(event) {
      if (!this.drag) return;
      this.drag.lastX = this.pointOf(event);
      const dx = this.pointOf(event) - this.drag.x;
      if (!this.drag.moved) {
        if (Math.abs(dx) < DRAG_THRESHOLD) return;
        this.drag.moved = true;
        this.dragging = true;
        this.stopAutoplay();

        // A drag against a move under way stops it where it has got to. A drag
        // the same way as the move finishes it at once and carries on from its
        // end, so the drag adds to the move instead of cutting it short.
        const heading = this.animation ? Math.sign(this.animationLeft - this.position) : 0;
        this.cancelAnimation(false);
        if (heading !== 0 && heading === Math.sign(-dx)) {
          this.viewport.scrollTo(this.along(this.animationLeft, 'instant'));
          if (this.targetIndex !== undefined) this.currentIndex = this.targetIndex;
        }

        // Room to travel either way in a wrapping carousel.
        this.rebaseLoop();
        this.viewport.style.scrollSnapType = 'none';
        this.root.classList.add('kv-carousel--grabbing');

        // Counted from this point, so the track does not jump by the distance
        // the pointer covered before the drag began. Where the track stood is
        // kept too: a row that moves by the screenful moves from there.
        this.drag.start = this.position;
        this.drag.left = this.position + dx;
      }
      this.position = this.drag.left - dx;
    }

    onDragUp(event) {
      window.removeEventListener('pointermove', this.onDragMove, true);
      window.removeEventListener('pointerup', this.onDragUp, true);
      window.removeEventListener('pointercancel', this.onDragUp, true);
      window.removeEventListener('blur', this.onDragAbort);

      const drag = this.drag;
      this.drag = null;

      // A press that never became a drag took nothing over.
      if (!drag || !drag.moved) {
        this.dragging = false;
        return;
      }

      this.dragging = false;
      this.root.classList.remove('kv-carousel--grabbing');

      if (this.destroyed) {
        this.viewport.style.scrollSnapType = '';
        return;
      }

      // The release of a drag must not also count as a click on whatever link
      // happens to be under the pointer. The click is caught on the window,
      // before any other listener, even one a page script placed around the
      // carousel to catch clicks early, such as a gallery switching its main
      // picture. Only a click inside this carousel is stopped. The carousel is
      // also marked for as long as that click can arrive.
      if (!event.aborted) {
        const swallow = (click) => {
          if (!this.root.contains(click.target)) return;
          click.preventDefault();
          click.stopPropagation();
        };
        this.root.setAttribute('data-kv-drag-release', '');
        window.addEventListener('click', swallow, { capture: true, once: true });
        setTimeout(() => {
          window.removeEventListener('click', swallow, { capture: true });
          this.root.removeAttribute('data-kv-drag-release');
        }, 0);
      }

      const dx = (event.aborted ? drag.lastX : this.pointOf(event)) - drag.x;
      const quick = performance.now() - drag.time < FLICK_MS;
      const item = this.releaseItem(dx, quick, drag.start);

      // Snapping stays lifted until the settling move ends. Restoring it here,
      // halfway between two items, would make the browser jump to the nearer one
      // before the move had a chance to start.
      if (item) {
        const real = item.dataset.kvCloneOf !== undefined
          ? Number(item.dataset.kvCloneOf)
          : this.visibleRealItems.indexOf(item);
        this.targetIndex = Math.max(0, real);
        this.scrollToLeft(Math.min(this.maxScroll, this.offsetOf(item)));
        this.updateIndex();
      } else {
        this.viewport.style.scrollSnapType = '';
      }
      this.restartAutoplay();
    }

    /*
      Where a released drag comes to rest, decided from where the track stopped:
      the item whose start the scroller has just passed, and how far into that
      item it got. Dragged forward, it moves on to the next item after a flick
      or once past DRAG_RATIO of the item; dragged back, it settles on the item
      it is inside after a flick, or unless the drag stopped short of taking it
      back that far. The copies of a wrapping carousel count as items, so the
      track never runs the long way round.

      A row that does not wrap and shows several items at once moves by a
      screenful, the way its arrows do: counted from the item the drag started
      on, one screenful on after a flick or once past DRAG_RATIO of it, and a
      further screenful for every whole one dragged, never past either end.
      Counting from the start keeps the row going the way it was dragged even
      when it stood between two screenfuls, as a trackpad or the arrows at the
      end of the row can leave it.
    */
    releaseItem(dx, quick, start) {
      let items = this.laidOutItems
        .map((el) => ({ el, left: this.offsetOf(el) }))
        .sort((a, b) => a.left - b.left);
      if (!items.length) return null;

      const perView = this.visibleCount;
      if (!this.loop && perView > 1 && start !== undefined && items.length > 1) {
        const max = this.maxScroll;
        const lefts = items.map((item) => Math.min(item.left, max));
        let last = lefts.findIndex((left) => left >= max - EDGE_EPSILON);
        if (last < 0) last = items.length - 1;

        let from = 0;
        let nearest = Infinity;
        lefts.forEach((left, i) => {
          const gap = Math.abs(left - start);
          if (gap < nearest - EDGE_EPSILON) {
            nearest = gap;
            from = i;
          }
        });
        from = Math.min(from, last);

        // Measured by how far the pointer travelled rather than the track,
        // which stops at either end while the pointer carries on.
        const screen = (items[1].left - items[0].left) * perView;
        const travel = Math.abs(dx);
        const whole = screen > 0 ? Math.floor(travel / screen) : 0;
        const rest = screen > 0 ? travel / screen - whole : 0;
        let screens = whole + (rest >= DRAG_RATIO ? 1 : 0);
        if (quick && screens === 0 && dx !== 0) screens = 1;

        const way = dx < 0 ? 1 : dx > 0 ? -1 : Math.sign(this.position - start);
        const target = Math.max(0, Math.min(last, from + way * screens * perView));
        return items[target].el;
      }

      // Distance from one stop to the next. By default the next item; for a
      // row that moves by the screenful, a whole screenful even where the last
      // step is shorter because the row ends.
      let fullSpan = null;
      if (!this.loop && perView > 1) {
        const max = this.maxScroll;
        const end = items.find((item) => item.left >= max - EDGE_EPSILON) || items[items.length - 1];
        if (items.length > 1) fullSpan = (items[1].left - items[0].left) * perView;
        items = items
          .filter((item, i) => i % perView === 0 && item.left < max - EDGE_EPSILON)
          .concat({ el: end.el, left: max });
      }

      const position = this.position;
      let stop = 0;
      items.forEach((item, i) => {
        if (item.left <= position + EDGE_EPSILON) stop = i;
      });
      const current = items[stop];
      const next = items[Math.min(items.length - 1, stop + 1)];
      const span = fullSpan || next.left - current.left;
      const into = span > 0 ? (position - current.left) / span : 0;

      let forward;
      if (dx < 0) forward = quick || into >= DRAG_RATIO;
      else if (dx > 0) forward = !quick && into > 1 - DRAG_RATIO;
      else forward = into >= 0.5;

      return (forward ? next : current).el;
    }

    /* Autoplay ------------------------------------------------------------- */

    scheduleAutoplay(delay = this.autoplayDelay) {
      if (!this.autoplayDelay || reducedMotion()) return;
      if (this.pauses && this.pauses.size) return;
      clearTimeout(this.autoplayTimer);
      this.autoplayDue = performance.now() + delay;
      this.autoplayTimer = setTimeout(() => this.autoplayTick(), delay);
    }

    autoplayTick() {
      this.autoplayTimer = null;
      if (this.destroyed || !this.root.isConnected) return;

      // Nothing to advance to, or the visitor is busy with the track: wait again.
      const idle =
        (this.pauses && this.pauses.size) ||
        this.touching ||
        this.dragging ||
        this.drag ||
        (this.loop && this.moving) ||
        this.visibleRealItems.length <= this.visibleCount;
      if (idle) {
        this.scheduleAutoplay();
        return;
      }

      // Without wrapping there is nowhere past the end, so the timed advance
      // starts over from the first item instead of stalling on the last one.
      if (!this.loop && this.position >= this.maxScroll - EDGE_EPSILON) {
        this.goTo(0);
      } else {
        this.goTo(this.baseIndex + 1, 1);
      }
      this.scheduleAutoplay(this.autoplayDelay + this.duration);
    }

    stopAutoplay() {
      clearTimeout(this.autoplayTimer);
      this.autoplayTimer = null;
    }

    // Any move the visitor makes starts the wait again rather than stopping it.
    restartAutoplay() {
      if (!this.autoplayDelay) return;
      this.autoplayLeft = undefined;
      this.stopAutoplay();
      this.scheduleAutoplay();
    }
  }

  const start = (scope) => {
    scope.querySelectorAll(SELECTOR).forEach((root) => {
      if (root.kvCarousel) return;
      root.kvCarousel = new KvCarousel(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => start(document));
  } else {
    start(document);
  }

  // Markup that arrives after the page has loaded, such as a popup filled from
  // a fetched fragment, hands its container over here to start its carousels.
  window.kvCarousels = { start: (scope) => start(scope || document) };

  // The theme editor swaps a section's markup without reloading the page, so
  // the replacement has to be picked up when it lands.
  document.addEventListener('shopify:section:load', (event) => start(event.target));

  // Carousels that move by themselves or by item are told when the theme editor
  // selects one of their blocks, and are stopped when their section goes away.
  // Plain rows ignore both.
  const carouselOf = (element) => {
    const root = element && element.closest ? element.closest(SELECTOR) : null;
    return root && root.kvCarousel && root.kvCarousel.indexed ? root.kvCarousel : null;
  };

  document.addEventListener('shopify:block:select', (event) => {
    const carousel = carouselOf(event.target);
    if (carousel) carousel.selectBlock(event.target);
  });

  document.addEventListener('shopify:block:deselect', (event) => {
    const carousel = carouselOf(event.target);
    if (carousel) carousel.deselectBlock();
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(SELECTOR).forEach((root) => {
      if (root.kvCarousel && root.kvCarousel.indexed) root.kvCarousel.destroy();
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kv-product-source"] && !Shopify.designMode) return;
  try {
    /*
    Rows that cannot be finished while the page is built finish themselves
    here. Three of them:

    - an order only the shop knows (best selling, or any order over a
      collection longer than the 50 products a theme is handed): the row asks
      the shop for this same section at the collection's own address, with the
      order in it, and puts the products it gets back in place of its own;
    - products the shop suggests for the product being looked at: the row asks
      for this same section at the suggestion address;
    - products the shopper looked at lately: the row starts empty and asks for
      this same section at the search address, handing over the handles the
      browser remembers, newest first; the shop draws those very products.
      Visits are remembered here too: from the address of the page, from the
      address the shopper came from, and from any product link they click.

    A row that gets nothing back keeps what it already shows, and a row that
    had nothing to show to begin with takes itself off the page.
  */
  if (window.kvProductSourceReady) return;
  window.kvProductSourceReady = true;

  const CONFIG = 'script[type="application/json"][data-kv-source-config]';
  const ITEM = '[data-kv-source-item]';
  const STORE_KEY = 'kv:recently-viewed';
  const REMEMBERED = 20;

  const read = (node) => {
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  };

  const rowOf = (node) =>
    node.closest('[data-kv-source-row]') || node.closest('.shopify-section') || node.parentNode;

  /*
    The carousel took stock of its slides when it was built, so a row whose
    items have just been swapped hands it the new list and asks it to lay
    itself out again. Building a second carousel over the same row would
    leave the arrows answering to both.
  */
  const remeasure = (row) => {
    const carousel = row && row.querySelector ? row.querySelector('.kv-carousel') : null;
    if (!carousel) return;
    const viewport = carousel.querySelector('.kv-carousel__viewport');
    if (viewport) viewport.scrollLeft = 0;
    const running = carousel.kvCarousel;
    if (!running) {
      if (window.kvCarousels) window.kvCarousels.start(row);
      return;
    }
    const track = carousel.querySelector('.kv-carousel__track');
    if (track && Array.isArray(running.realItems)) {
      running.realItems = [...track.children].filter((el) => el.classList.contains('kv-carousel__item'));
    }
    if (typeof running.apply === 'function') running.apply();
  };

  const fetchDocument = async (address) => {
    const response = await fetch(address, { credentials: 'same-origin' });
    if (!response.ok) throw new Error(String(response.status));
    return new DOMParser().parseFromString(await response.text(), 'text/html');
  };

  const put = (script, items) => {
    const host = script.parentNode;
    host.querySelectorAll(ITEM).forEach((item) => item.remove());
    items.forEach((item) => host.insertBefore(item, script));
  };

  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /*
    A section may hold more than one such row, and asking for the section
    again brings all of them back. Every item carries the key of the row that
    drew it, so each row takes only its own products however the rows in that
    answer are arranged.
  */
  const itemsFor = (doc, config) => {
    const all = [...doc.querySelectorAll(ITEM)];
    if (!config.rowKey) return all;
    // Only this row's own products. An answer that holds none of them means
    // this row has nothing there, never that another row's products will do.
    return all.filter((item) => item.getAttribute('data-kv-source-key') === config.rowKey);
  };

  // The row that asked keeps leaving out the product being looked at.
  const withoutCurrent = (items, config) =>
    items.filter((item) => !config.currentHandle || item.getAttribute('data-kv-source-handle') !== config.currentHandle);

  // Fisher-Yates: every order is equally likely.
  const shuffle = (script) => {
    const host = script.parentNode;
    const items = [...host.querySelectorAll(ITEM)];
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const swap = items[i];
      items[i] = items[j];
      items[j] = swap;
    }
    items.forEach((item) => host.insertBefore(item, script));
    remeasure(rowOf(script));
  };

  /* An order only the shop can give --------------------------------------- */

  /*
    Several collections are asked about one at a time, because the shop can
    only be asked about one collection. Their answers are then put back
    together as one list: by the value each card carries when the order has
    one, and otherwise a card from each collection in turn, so that later
    collections are not simply cut off by the first collection filling the
    row. Sales are the shop's own count and are never handed to a theme, so
    "best selling" is the one order that has no value to merge on.
  */
  const merge = (lists, config) => {
    const flat = lists.flat();
    // One collection is already in the shop's own order, which is the truest
    // there is: putting it in order again by the value on the cards could only
    // disagree with the shop over how two names or two equal prices compare.
    if (lists.length < 2) return flat;
    const sortable = flat.length > 0 && flat.every((item) => item.hasAttribute('data-kv-source-sort'));

    if (sortable) {
      const valueOf = (item) => item.getAttribute('data-kv-source-sort') || '';
      const numeric = flat.every((item) => valueOf(item) !== '' && !Number.isNaN(Number(valueOf(item))));
      const order = String(config.order || '');
      const down = order === 'price_desc' || order === 'title_desc' || order === 'newest';
      flat.sort((one, other) => {
        const a = valueOf(one);
        const b = valueOf(other);
        const side = numeric ? Number(a) - Number(b) : a.localeCompare(b);
        return down ? -side : side;
      });
      return flat;
    }

    const taken = [];
    for (let round = 0; taken.length < flat.length; round += 1) {
      let moved = false;
      lists.forEach((list) => {
        if (round < list.length) {
          taken.push(list[round]);
          moved = true;
        }
      });
      if (!moved) break;
    }
    return taken;
  };

  const askForOrder = async (script, config) => {
    const handles = (config.collections || []).filter(Boolean);
    if (!handles.length || !config.sectionId || !config.shopOrder) return;
    const wanted = Number(config.limit) || 12;
    const seen = new Set();
    const lists = [];

    for (const handle of handles) {
      const address =
        root() +
        'collections/' +
        encodeURIComponent(handle) +
        '?sort_by=' +
        encodeURIComponent(config.shopOrder) +
        '&section_id=' +
        encodeURIComponent(config.sectionId);
      const doc = await fetchDocument(address);
      const list = [];
      for (const item of withoutCurrent(itemsFor(doc, config), config)) {
        if (list.length >= wanted) break;
        const key = item.getAttribute('data-kv-source-handle');
        if (key && seen.has(key)) continue;
        if (key) seen.add(key);
        list.push(document.importNode(item, true));
      }
      lists.push(list);
    }

    const picked = merge(lists, config).slice(0, wanted);
    if (!picked.length) return;
    const row = rowOf(script);
    put(script, picked);
    if (row && row.hidden) row.hidden = false;
    remeasure(row);
  };

  /* Products the shop suggests -------------------------------------------- */

  const askForSuggestions = async (script, config) => {
    if (!config.productId || !config.sectionId) return;
    const row = rowOf(script);
    const address =
      root() +
      'recommendations/products?section_id=' +
      encodeURIComponent(config.sectionId) +
      '&product_id=' +
      encodeURIComponent(config.productId) +
      '&intent=' +
      encodeURIComponent(config.intent || 'related') +
      '&limit=' +
      encodeURIComponent(config.limit || 12);
    const doc = await fetchDocument(address);
    const items = withoutCurrent(itemsFor(doc, config), config).map((item) =>
      document.importNode(item, true)
    );
    if (!items.length) {
      if (row && !script.parentNode.querySelector(ITEM)) row.hidden = true;
      return;
    }
    put(script, items);
    if (row && row.hidden) row.hidden = false;
    remeasure(row);
  };

  /* Products this shopper looked at ---------------------------------------- */

  const history = () => {
    try {
      const list = JSON.parse(window.localStorage.getItem(STORE_KEY) || '[]');
      return Array.isArray(list) ? list.filter((handle) => typeof handle === 'string') : [];
    } catch (error) {
      return [];
    }
  };

  const remember = (handle) => {
    if (!handle) return;
    try {
      const list = history().filter((seen) => seen !== handle);
      list.unshift(handle);
      window.localStorage.setItem(STORE_KEY, JSON.stringify(list.slice(0, REMEMBERED)));
    } catch (error) {
      /* A browser that refuses storage simply never fills such a row. */
    }
  };

  const handleOf = (address) => {
    const found = /\/products\/([^/?#]+)/.exec(address || '');
    if (!found) return '';
    try {
      return decodeURIComponent(found[1]);
    } catch (error) {
      // An address that cannot be decoded is taken as it stands rather than
      // stopping everything else this script does.
      return found[1];
    }
  };

  /*
    The shop draws the cards, so they are the same cards as everywhere else:
    the row asks for its own section again and hands over the handles it
    remembers, in the address, newest first. A shop hands a theme at most
    twenty products by handle in one render, so that is where the list is cut.
  */
  const SEEN_MARKER = 'kvsource';
  const SEEN_CAP = 20;

  const showSeen = async (script, config) => {
    const row = rowOf(script);
    const wanted = Math.min(Number(config.limit) || 12, SEEN_CAP);
    const handles = history()
      .filter((handle) => handle && handle !== config.currentHandle)
      .slice(0, wanted);

    if (!handles.length || !config.sectionId) {
      if (row) row.hidden = true;
      return;
    }

    const address =
      root() +
      'search?type=product&q=' +
      encodeURIComponent([SEEN_MARKER].concat(handles).join(' ')) +
      '&section_id=' +
      encodeURIComponent(config.sectionId);

    let items = [];
    try {
      const doc = await fetchDocument(address);
      items = itemsFor(doc, config).map((item) => document.importNode(item, true));
    } catch (error) {
      /* A row that cannot ask takes itself off the page below. */
    }

    if (!items.length) {
      if (row) row.hidden = true;
      return;
    }

    put(script, items);
    if (row) row.hidden = false;
    remeasure(row);
  };

  /* Wiring ----------------------------------------------------------------- */

  const run = (script) => {
    if (script.dataset.kvSourceDone === 'true') return;
    script.dataset.kvSourceDone = 'true';
    const config = read(script);
    if (!config) return;

    // A random row that already holds its products only needs a fresh order on
    // every visit. A row whose products are still to be fetched has to fetch
    // them first, and is shuffled once they are in.
    const fetches = config.mode === 'recently_viewed' || config.mode === 'recommended';
    if (config.order === 'random' && !fetches) {
      shuffle(script);
      return;
    }

    if (config.mode === 'recently_viewed') {
      showSeen(script, config)
        .then(() => {
          if (config.order === 'random') shuffle(script);
        })
        .catch(() => {
          /* The row simply stays off the page. */
        });
      return;
    }

    const work = config.mode === 'recommended' ? askForSuggestions(script, config) : askForOrder(script, config);
    work
      .then(() => {
        if (config.order === 'random') shuffle(script);
      })
      .catch(() => {
        /* The row keeps the products it was built with. */
      });
  };

  const start = (scope) => {
    (scope || document).querySelectorAll(CONFIG).forEach(run);
  };

  /*
    A visit is remembered wherever a row like this sits, so a row fills up
    whether or not it is also placed on the product page.
  */
  const rememberVisits = () => {
    const here = handleOf(window.location.pathname);
    if (here) remember(here);
    else if (document.referrer && document.referrer.indexOf(window.location.origin) === 0) {
      remember(handleOf(document.referrer));
    }
  };

  /*
    A click on a link to a product counts as a visit, but only a link to this
    shop: a link somewhere else may hold an address that looks the same. A
    click that ends a drag of the row does not count, because the shopper was
    moving the row rather than opening the product.
  */
  let pressedAt = null;

  document.addEventListener(
    'pointerdown',
    (event) => {
      pressedAt = { x: event.clientX, y: event.clientY };
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest && event.target.closest('a[href*="/products/"]');
      if (!link) return;
      if (pressedAt) {
        const moved = Math.abs(event.clientX - pressedAt.x) + Math.abs(event.clientY - pressedAt.y);
        pressedAt = null;
        if (moved > 10) return;
      }
      let address = null;
      try {
        address = new URL(link.getAttribute('href'), window.location.href);
      } catch (error) {
        return;
      }
      if (address.origin !== window.location.origin) return;
      remember(handleOf(address.pathname));
    },
    true
  );

  rememberVisits();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start());
  else start();

  document.addEventListener('shopify:section:load', (event) => start(event.target));
  } catch(e) { console.error(e); }
})();

})();
